// Mock data for DaddyAnna clone (frontend-only). Replace with backend later.

export const contact = {
  whatsapp: "https://wa.link/daddyhere",
  telegram: "https://t.me/officialdaddyanna",
  signal: "https://signal.me/#p/+918750268130",
  phone: "+91 87502 68130",
};

export const logo =
  "https://daddyanna.com/wp-content/uploads/2024/05/dDA-logo-New-e1716385632670.png";

export const nav = [
  { label: "Home", to: "/" },
  { label: "Cricket ID", to: "/cricket-id" },
  { label: "How to Play", to: "/how-to-play" },
  { label: "Blog", to: "/blog" },
  { label: "About Us", to: "/about-us" },
  { label: "Contact", to: "/contact-us" },
];

export const hero = {
  badge: "Trusted Since 2015 \u00b7 50,000+ Players",
  title: "Online Cricket ID",
  titleHighlight: "with DaddyAnna",
  subtitle:
    "Get your verified online cricket id in under 2 minutes. Play live cricket, sports exchange & 650+ casino games with instant deposits and 10-minute withdrawals.",
  points: [
    "ID activated in 2 minutes on WhatsApp",
    "Instant UPI deposit from \u20b9100",
    "Fastest withdrawal in 10\u201315 minutes",
  ],
  image:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_neon-sports-id/artifacts/6ihl438g_banner2.jpg",
};

export const stats = [
  { value: "50,000+", label: "Active Players" },
  { value: "650+", label: "Live Games" },
  { value: "2 Min", label: "ID Activation" },
  { value: "24x7", label: "Support" },
];

export const about = {
  heading: "What is a DaddyAnna Online Cricket ID?",
  paragraphs: [
    "An online cricket id lets you connect directly to live cricket exchange platforms where you can follow every match, track real-time odds and take part in cricket action \u2014 all from your phone.",
    "With our reliable service, getting a cricket betting id is simple, quick and dependable. Operating since 2015, DaddyAnna is recognised as one of India's most trusted online cricket id providers with round-the-clock support.",
  ],
  image:
    "https://daddyanna.com/wp-content/uploads/2025/03/daddy-anna-dp-min-1024x1024.png",
};

export const whyChoose = [
  {
    title: "Oldest & Most Trusted",
    desc: "Serving real players since 2015. We are a company, not a middleman \u2014 which makes us the most trusted online cricket id choice in India.",
    icon: "ShieldCheck",
  },
  {
    title: "Safe & Secure",
    desc: "Every online cricket id is SSL-encrypted with complete privacy. Your data and funds always stay protected \u2014 never shared with third parties.",
    icon: "Lock",
  },
  {
    title: "All Cricket Matches",
    desc: "IPL, World Cup, BBL, PSL, T20 and every international match \u2014 covered live with a fast, dependable odds API you can rely on.",
    icon: "Trophy",
  },
  {
    title: "24/7 Customer Support",
    desc: "Our team is online around the clock. Any issue with your cricket id gets solved in under 60 seconds on WhatsApp or Telegram.",
    icon: "Headphones",
  },
];

export const keyFeatures = [
  "Unlimited Sports & Casino",
  "100% Transparency & Security",
  "Cricket ID in just 2 minutes",
  "5% Welcome Bonus",
  "10% Loss Commission",
  "24/7 Customer Support",
  "Safe & Secure Transactions",
  "Fastest Withdrawal (10\u201315 min)",
];

export const services = [
  {
    title: "Online Cricket ID",
    desc: "Play IPL, World Cup, T20 and Test matches with the best live odds.",
    icon: "Target",
  },
  {
    title: "Live Sports Exchange",
    desc: "Full back & lay options on cricket, football, tennis and more.",
    icon: "TrendingUp",
  },
  {
    title: "Casino ID",
    desc: "Teen Patti, Andar Bahar, Roulette, Blackjack and 250+ live tables.",
    icon: "Dices",
  },
  {
    title: "Aviator & Crash Games",
    desc: "Fast, high-thrill earning games with instant results.",
    icon: "Rocket",
  },
  {
    title: "Refer & Earn",
    desc: "Invite friends to DaddyAnna and earn lifetime commission.",
    icon: "Gift",
  },
  {
    title: "Instant Withdrawals",
    desc: "UPI, Bank and USDT payouts credited in just 3\u20135 minutes.",
    icon: "Wallet",
  },
];

export const steps = [
  {
    step: "01",
    title: "Message on WhatsApp",
    desc: 'Send us "Get Cricket ID" on WhatsApp \u2014 no forms, no document uploads.',
  },
  {
    step: "02",
    title: "Share Your Details",
    desc: "Give us your name and a preferred username for your new online cricket id.",
  },
  {
    step: "03",
    title: "Get ID in 2 Minutes",
    desc: "Receive your cricket id and password within 2 minutes, 100% manual & secure.",
  },
  {
    step: "04",
    title: "Add Balance & Play",
    desc: "Add balance via UPI from \u20b9100 and start playing your favourite games.",
  },
];

export const exchanges = [
  {
    name: "TAJ777.COM",
    logo: "https://daddyanna.com/wp-content/uploads/2023/05/logo.png.webp",
    bonus: "5% Welcome Bonus",
    commission: "10% Loss Commission",
    user: "Tdemo4",
    pass: "Vishnu@123",
  },
  {
    name: "ALLPANELEXCH.COM",
    logo: "https://daddyanna.com/wp-content/uploads/2025/03/all-pannel-1.png",
    bonus: "5% Welcome Bonus",
    commission: "10% Loss Commission",
    user: "Pdemo99",
    pass: "Vishnu@1234",
  },
  {
    name: "LORDSEXCH.COM",
    logo: "https://daddyanna.com/wp-content/uploads/2023/05/logo-login.png.webp",
    bonus: "5% Welcome Bonus",
    commission: "10% Loss Commission",
    user: "Ldemo45",
    pass: "Ab123456",
  },
  {
    name: "TIGER365.ME",
    logo: "https://daddyanna.com/wp-content/uploads/2023/11/logo-text.png",
    bonus: "5% Welcome Bonus",
    commission: "10% Loss Commission",
    user: "daddydemo",
    pass: "Vishnu@123",
  },
];

export const process = [
  {
    title: "100% Trusted Service",
    desc: "Operating with real experience and expertise since 2015. A registered company you can rely on.",
    icon: "BadgeCheck",
  },
  {
    title: "Most Popular Sports",
    desc: "Bet on cricket across national & international leagues, plus tennis, football, rugby and casino.",
    icon: "Star",
  },
  {
    title: "24/7 Support",
    desc: "Friendly, knowledgeable agents ready to help via WhatsApp, Telegram or live chat anytime.",
    icon: "Clock",
  },
  {
    title: "Instant Withdraw & Refill",
    desc: "Withdrawals credited straight to your bank instantly, from minimum to maximum amount.",
    icon: "Zap",
  },
];

export const founder = {
  name: "Anna",
  role: "Founder & Cricket ID Expert",
  avatar:
    "https://daddyanna.com/wp-content/uploads/2026/06/d4f2fc46-76f5-441f-81c1-a02a5b9a4dbc.jpg",
  bio: "Hi, I'm Anna, founder of DaddyAnna since 2015 with 9+ years of experience in the online sports exchange and cricket id industry. I started DaddyAnna because users deserved verified, fast and transparent cricket id providers. Today, 50,000+ users trust us for instant IDs, UPI deposits from \u20b9100 and 10-minute withdrawals.",
};

export const faqs = [
  {
    q: "Is it safe to take a Cricket ID from DaddyAnna?",
    a: "Absolutely. Over 10,000 users trust us daily and every transaction is fully encrypted and secure.",
  },
  {
    q: "How long do withdrawals take?",
    a: "On average 3\u20135 minutes. In rare cases of bank delay it may take up to 15 minutes.",
  },
  {
    q: "What is the minimum deposit?",
    a: "You can start with just \u20b9100 via UPI, Bank or USDT.",
  },
  {
    q: "Does it work on mobile?",
    a: "Yes, the platform is fully mobile-optimised. There is no need to download any app.",
  },
  {
    q: "What if there is a problem with my ID?",
    a: "Our 24x7 WhatsApp support resolves most issues within a minute.",
  },
];

export const restrictedTerritories = [
  "Afghanistan", "Algeria", "Australia", "Bosnia and Herzegovina", "Bulgaria",
  "Canada", "China", "Cuba", "Cyprus", "Denmark", "Ethiopia", "France",
  "Germany", "Gibraltar", "Iran", "Iraq", "Ireland", "Italy", "North Korea",
  "Laos", "Macau", "Malta", "Myanmar", "Netherlands", "New Zealand", "Poland",
  "Portugal", "Puerto Rico", "Qatar", "Romania", "Singapore", "Slovakia",
  "South Africa", "Spain", "Sudan", "Syria", "Taiwan", "Turkey", "Uganda",
  "United Kingdom", "United States", "Yemen",
];

export const gallery = [
  "https://images.unsplash.com/photo-1728659964407-ed9a942ec2de?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1587385789097-0197a7fbd179?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1509478861672-91e9a2f90c04?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1545804913-688517980abc?w=800&q=80&auto=format&fit=crop",
];

export const winners = [
  { name: "Rahul S.", amount: "12,500", game: "IPL Match Odds", city: "Mumbai" },
  { name: "Amit K.", amount: "8,200", game: "Aviator", city: "Delhi" },
  { name: "Priya M.", amount: "24,750", game: "Teen Patti", city: "Pune" },
  { name: "Sandeep R.", amount: "5,600", game: "Andar Bahar", city: "Jaipur" },
  { name: "Vikas T.", amount: "31,000", game: "Cricket Exchange", city: "Lucknow" },
  { name: "Neha G.", amount: "9,900", game: "Lightning Roulette", city: "Kolkata" },
  { name: "Arjun P.", amount: "16,400", game: "Dragon Tiger", city: "Chennai" },
  { name: "Rohit V.", amount: "42,300", game: "World Cup Odds", city: "Ahmedabad" },
  { name: "Kiran D.", amount: "7,150", game: "Crazy Time", city: "Hyderabad" },
  { name: "Manish B.", amount: "19,800", game: "Baccarat", city: "Indore" },
];

